import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ToolCard from './ToolCard';

const ToolsGrid = React.memo(({ tools }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.6,
        type: "spring",
        stiffness: 100,
        damping: 12
      }
    }
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div 
        className="tools-grid"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
        key={tools.length} // Force re-animation when tools change
      >
        {tools.length === 0 ? (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            className="no-results"
            style={{
              gridColumn: '1 / -1',
              textAlign: 'center',
              padding: '60px 20px',
              color: '#888',
              fontSize: '1.2rem'
            }}
          >
            <div style={{ fontSize: '4rem', marginBottom: '20px' }}>🔍</div>
            <div>No tools found in this galaxy...</div>
            <div style={{ fontSize: '0.9rem', marginTop: '10px', opacity: 0.7 }}>
              Try adjusting your search or category filters
            </div>
          </motion.div>
        ) : (
          tools.map((tool, index) => (
            <motion.div
              key={tool.id}
              variants={itemVariants}
              layout
              transition={{ duration: 0.3 }}
            >
              <ToolCard tool={tool} />
            </motion.div>
          ))
        )}
      </motion.div>
    </AnimatePresence>
  );
});

// Custom comparison function for better memoization
ToolsGrid.displayName = 'ToolsGrid';

export default ToolsGrid;